import withCountry from 'enhancers/withCountry';
import withHistoryPageQuery, { WithHistoryPageQueryProps } from 'enhancers/withHistoryPageQuery';
import * as React from 'react';
import styled from 'styled-components';
import Section from 'wrappers/Section/Section';

type Props = WithHistoryPageQueryProps;

export const HistoryPage: React.SFC<Props> = props => {
  const background =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.History &&
    props.data.fetch.Common.History.Background
      ? props.data.fetch.Common.History.Background
      : '';
  return (
    <Container style={{ background }}>
      <Section>
        <div>
          {!props.loading &&
            props.data &&
            props.data.fetch.Common.History &&
            props.data.fetch.Common.History.Gallery &&
            props.data.fetch.Common.History.Gallery.map((item, key) => (
              <div key={key}>
                <Image src={item.Image.src} alt="" />
              </div>
            ))}
        </div>
      </Section>
    </Container>
  );
};

const Image = styled.img`
  width: 100%;
`;

const Container = styled.div`
  padding-top: 25px;
`;

export default withCountry(withHistoryPageQuery(HistoryPage));



// WEBPACK FOOTER //
// ./src/pages/HistoryPage/HistoryPage.tsx